'use strict';

export default class BasePickerController {
	constructor($timeout, $q, $element, $scope, i18n) {
		this.$timeout = $timeout;
		this.$q = $q;
		this.$element = $element;
		this.$scope = $scope;
		this.i18n = i18n;

		this.internalSet = false;
		this._items = null;
		this._tempValue = null;
		this._notFoundClicked = false;
		this.autoCompleteSearchText = '';
		this.availableNotFoundButton = false;
		this.loadedItemsSearchText = null;
		this.loadedItemsCompletely = false;
		this._valueReset = false;
		this._loadOnTyping = false;
		this.isLoading = false;
		this._isTyping = false;
		this._isAutoTyping = false;

		this.defaultPickerLabel = i18n.get('components.mx-picker.defaultLabel');

		$scope.initCurrentElement = function (element) {
			var itemEl = $(element.closest('.md-autocomplete-suggestion'));
			if (element.hasClass('item-title-info')) {
				itemEl.addClass('count-line');
			} else {
				itemEl.removeClass('count-line');
			}
		};

		this.searchInput = null;

		return this;
	}

	$onInit() {
		let selectedItems = Array.isArray(this.selectedItems) ? this.selectedItems : [];
		this.itemTitleField = this.itemTitleField || 'name';
		this.itemIdField = this.itemIdField || 'id';
		this.notFoundMessage = this.notFound && this.notFound.message ? this.notFound.message : this.i18n.get('components.mx-picker.defaultNotFoundMessage');

		this.noLabel = (this.noLabel || '').toString().toLowerCase() === 'true';
		this.itemsIsPlainArray = typeof this.itemsIsPlainArray === 'string' ? (this.itemsIsPlainArray || '').toLowerCase() === 'true' : this.itemsIsPlainArray || false;
		this._setItemsValue(this.items);
		this._setLoadOnTyping(this.loadOnTyping);

		Object.defineProperties(this, {
			selectedItems: {
				get: () => selectedItems,
				set: (newItems) => {
					if (Array.isArray(newItems)) {
						selectedItems = newItems;
					}
				},
			},
			items: {
				get: () => this._items,
				set: this._setItemsValue,
			},
			loadOnTyping: {
				get: () => this._loadOnTyping,
				set: this._setLoadOnTyping,
			},
			_isTyping: {
				get: () => this._isAutoTyping,
				set: (value) => {
					this._isAutoTyping = value;
					this._setLabels();
				},
			},
		});

		if (this.loadOnTyping && !this.loadDelay) {
			this.loadDelay = 300;
		}

		this._formatTitle();

		if (this.loadItems && !this.loadOnTyping) {
			this.reload().then(() => this.$scope.$evalAsync(() => {}));
		}

		this.$timeout(() => {
			this.searchInput = this.$element.find('input');

			if (this.searchInput) {
				this.searchInput.on('focus', () => {
					this._isTyping = true;
					this.showingHints(true);
				});

				this.searchInput.on('blur', ($event) => {
					var relatedTarget = $event.relatedTarget || document.activeElement;
					if (relatedTarget && (relatedTarget.classList.contains('item-load-more') || relatedTarget.classList.contains('mx-picker--not-found-button'))) {
						$event.stopPropagation();
						$event.preventDefault();
					} else {
						this._isTyping = false;
						this.showingHints(false);

						if (this.autoCompleteSearchText) {
							this.$timeout(() => {
								if (this.items.length === 1 && this.autoCompleteSearchText) {
									this.selectedItem = this.items[0];
								} else {
									if (this.autoCompleteSearchText && (!this.model || !this.selectedItem) && !this._notFoundClicked) {
										this._setAutoCompleteValue(null);
									}
								}
							}, 1500);
						} else if (this._valueReset) {
							this._setAutoCompleteValue(null);
							this._valueReset = false;
						}
					}
				});
			}
		});

		this.setNotFoundButtonAvailability();

		mx.components.FormControlControllerBase.call(this, this.$timeout);
	}

	$onChanges(changes) {
		if (changes.label) {
			this._formatTitle();
		}
	}

	_setLabels() {
		if ((this.selectedItems && this.selectedItems.length > 0) || this._isTyping) {
			this.autoPlaceholder = this.defaultPickerLabel;
		} else {
			this.autoPlaceholder = this.label;
		}
	}

	onNavigateItem(item) {
		if (this.navigateItem) {
			this.navigateItem(item);
		}
	}

	_setItemsFromBrowseLookup(data) {
		this.autoCompleteSearchText = '';
		this._items = [];
		this.resetItemsCache();

		if (data === null) {
			//clear selection
			this.model = null;
		} else {
			let items = Array.isArray(data) ? data : typeof data !== 'undefined' ? [data] : [];

			if (!this.single && Array.isArray(this.selectedItems) && this.selectedItems.length > 0 && !this.replaceOnBrowseLookup) {
				const selectedIds = this.selectedItems.map((item) => this.getId(item));
				const newItems = items.filter((item) => !selectedIds.includes(this.getId(item)));
				items = this.selectedItems.concat(newItems);
			}

			this.setSelectedItems(items);

			this.setModelInternal(this.selectedItemsToValue());

			if (this.searchInput) {
				this.searchInput.focus();
			}
		}
	}

	async onBrowseLookup() {
		if (this.browseLookup) {
			try {
				const data = await this.browseLookup(this.model);
				this._setItemsFromBrowseLookup(data);
			} catch (e) {
				mx.logCatch(e);
			}
		}
	}

	blur($event) {
		this.focus = false;

		if (typeof this.onBlur === 'function') {
			this.onBlur($event);
		}

		if (Array.isArray(this.items) && this.items.length > 6) {
			this.resetItemsCache();
		}
	}

	_setLoadOnTyping(val) {
		this._loadOnTyping = val === 'true' || val === true;
	}

	_setFirstValue() {
		if (this.model === null || this.model === undefined) {
			var defNotHiddenItem;

			if (this.default !== null && this.default !== undefined && this.itemIdField) {
				defNotHiddenItem = (this._items || []).filter((it) => !it.Hidden && ((it[this.itemIdField] || '') + '').toLowerCase() === (this.default + '').toLowerCase())[0];
			} else if (this.setFirstSelected) {
				defNotHiddenItem = (this._items || []).filter((it) => !it.Hidden)[0];
			}

			if (defNotHiddenItem) {
				this.setSelectedItems([defNotHiddenItem]);
				this.setModelInternal(this.selectedItemsToValue());
			}
		}
	}

	_setItemsValue(value) {
		var modelIsSet = this.model !== null && this.model !== undefined;
		var resetModel = modelIsSet && this._items && this._items.length > 0 && (!value || value.length === 0);
		this._items = value || [];
		this.isLoading = false;
		this._notFoundClicked = false;

		if (resetModel) {
			this.model = null;
		}

		this.itemsIsPlainArray = this._items.length > 0 ? typeof this._items[0] !== 'object' : this.itemsIsPlainArray;

		if (this._items.length > 0) {
			var isAddedEmpty = (this._items || []).some((it) => it[this.itemIdField] === undefined || it[this.itemIdField] === null);
			if (this.allowEmpty === 'true' && !isAddedEmpty && this.itemIdField && this.itemTitleField) {
				var emptyItem = {};
				emptyItem[this.itemIdField] = null;
				emptyItem[this.itemTitleField] = '';
				this._items.unshift(emptyItem);
			}

			if (this._tempValue !== null) {
				this._setSelectedItemsByValue(this._tempValue);
				this.setModelInternal(this.selectedItemsToValue());

				if (this.model === null && this._tempValue === 0) {
					this._setFirstValue();
				}
				this._tempValue = null;
			} else {
				if (modelIsSet && !this.loadOnTyping) {
					var modelId = this.model;

					//reset Value if the selected Items not in list anymore
					this._setSelectedItemsByValue(this._modelToValues(modelId));
					this.setModelInternal(this.selectedItemsToValue());
				}

				this._setFirstValue();
			}
		}
	}

	onValueChanging(value) {
		if (this.internalSet) {
			return value;
		}

		if (value !== null && value !== undefined && value !== '') {
			var valueArray = this._modelToValues(value);

			if (valueArray.length !== 0) {
				if (this.loadOnTyping) {
					//try get Display Strings

					this.setSelectedItems(this._valuesToItems(valueArray));
					return value;
				}
				var items = this.items;

				if (items && items.length > 0) {
					this._setSelectedItemsByValue(valueArray);
					return this.selectedItemsToValue();
				} else if (this.isLoading) {
					this._tempValue = value;
					return value;
				} else {
					this._tempValue = value;
					this.$timeout(() => {
						this._tempValue = null;
					}, 200);
				}
			}
		}

		this.setSelectedItems([]);
		return null;
	}

	_modelToValues(value) {
		let throwError = false;
		let valueArray = null;

		if (typeof value === 'string' && !isNaN(value)) {
			value = Number(value);
		} else if (Array.isArray(value)) {
			if (value.length > 0 && typeof value[0] === 'object') {
				throwError = true;
			}
			valueArray = value;
		} else if (typeof this.separatorChar === 'string' && this.separatorChar.length === 1) {
			valueArray = this.convertValueWithSeparatorChar(value);
		} else if (typeof value === 'object') {
			throwError = true;
		}

		if (throwError) {
			throw new Error('Picker control does not recognize assigned data type');
		}
		if (!valueArray) {
			valueArray = [value];
		}
		return valueArray;
	}

	_setSelectedItemsByValue(value) {
		var valueArray = this._modelToValues(value);
		//var valueArray = Array.isArray(value) ? value : [value];
		var items = this.items;

		if (items && items.length > 0) {
			var selectedItems = [];
			for (var i = 0; i < items.length; i++) {
				if (valueArray.indexOf(this.getId(items[i])) >= 0) {
					selectedItems.push(items[i]);

					if (selectedItems.length === valueArray.length) {
						break;
					}
				}
			}

			this.setSelectedItems(selectedItems);
		}
	}

	notFoundClick(event) {
		if (this.notFound && this.notFound.buttonClick) {
			this._notFoundClicked = true;
			this.notFound.buttonClick();
			this.availableNotFoundButton = false;
			this.resetItemsCache();
		}

		event.preventDefault();
		this.searchInput.focus();
	}

	loadMoreClick() {
		if (this.loadMoreConfig && this.loadMoreConfig.onClick) {
			this.loadMoreConfig.onClick();
			this.resetItemsCache();
		}

		return true;
	}

	clear() {
		this.setSelectedItems([]);
		this.setModelInternal(null);
		this.autoCompleteSearchText = '';
		this.searchInput.focus();
	}

	setNotFoundButtonAvailability(makeCall) {
		if (this.notFound) {
			const isConfigured = typeof this.notFound.buttonClick === 'function';
			if (!this.availableNotFoundButton && isConfigured && makeCall) {
				this.notFound.buttonClick(true);
			}
			this.availableNotFoundButton = isConfigured;
		}
	}

	_valuesToItems(values) {
		const items = values.map((val) => {
			var item = {};
			item[this.itemIdField] = val;
			item[this.itemTitleField] = ' ';
			return item;
		});

		this.loadItems(null, this, items);
		return items;
	}

	getId(item) {
		if (this.itemsIsPlainArray) {
			return item;
		}
		if (!item) {
			return null;
		}
		return item[this.itemIdField];
	}

	getTitle(item, isDropdown) {
		if (this.itemsIsPlainArray) {
			return item;
		}
		if (!item) {
			return null;
		}
		return item[(isDropdown && this.itemDropdownLabelField) || this.itemTitleField];
	}

	setModelInternal(value) {
		this.internalSet = true;
		this.model = value;
		this.internalSet = false;
	}

	isWildcardSearch(searchText) {
		return searchText && searchText.indexOf('%') > -1;
	}

	async reload(isAuto) {
		var searchText = this.autoCompleteSearchText ? this.autoCompleteSearchText.toLowerCase() : '';
		if (
			this.loadedItemsSearchText &&
			!this.isWildcardSearch(searchText) &&
			searchText.startsWith(this.loadedItemsSearchText) &&
			(this.loadedItemsCompletely || searchText.length === this.loadedItemsSearchText.length)
		) {
			if (this.loadedItemsSearchText !== searchText) {
				this.items = this.filterItemsByTitle(searchText);
				this.loadedItemsSearchText = searchText;
			}

			return this.items;
		}

		this.isLoading = true;
		const data = await this.loadItems(searchText, this);
		this.resetItemsCache();
		var items = [];
		if (Array.isArray(data)) {
			items = data;
		} else if (data && data.items) {
			items = data.items;
			if (!this.isWildcardSearch(data.searchText)) {
				this.loadedItemsSearchText = data.searchText;
				this.loadedItemsCompletely = data.all;
			}

			if (!data.all) {
				items.push({
					empty: true,
					init: function () {},
				});
			}
		}

		items = this.filterSelectedItems(items);

		if (isAuto) {
			this._items = items;
		} else {
			this.items = items;
		}
		this.isLoading = false;

		return this.items;
	}

	filterSelectedItems(items) {
		return items;
	}

	resetItemsCache() {
		this.loadedItemsSearchText = null;
		this.loadedItemsCompletely = false;
	}

	async autoCompleteSearch() {
		if (this.loadOnTyping && this.loadItems && !this.autoCompleteSearchText) {
			return [];
		}

		let items = this.loadOnTyping && this.loadItems ? await this.reload(true) : this.filterItemsByTitle(this.autoCompleteSearchText);

		if (items.length === 1 && !this.focus && this.autoCompleteSearchText) {
			this.setSelectedItems((this.selectedItems || []).concat(items));
			this.setModelInternal(this.selectedItemsToValue());
			this.autoCompleteSearchText = '';
		}
		return items;
	}

	filterItemsByTitle(query) {
		query = (query || '').toLowerCase();
		const filteredItems = query ? this.items.filter((item) => this.getTitle(item).toLowerCase().indexOf(query) !== -1) : this.items;
		return this.filterSelectedItems(filteredItems);
	}

	autoCompleteSelectedItemChange(item) {
		const itemValue = item ? this.getId(item) : null;
		if (itemValue !== this.model) {
			if (!itemValue) {
				if (this._isTyping) {
					this._valueReset = true;
					return;
				}
			}

			this._setAutoCompleteValue(itemValue);
		} else if (item === undefined) {
			this.autoCompleteSearchText = '';
		}

		this._valueReset = false;
	}

	_onAutoCompleteItemSelected() {
		//abstract method
	}

	_setAutoCompleteValue(value) {
		this.internalSet = true;
		this._onAutoCompleteItemSelected(value);
		if (!value) {
			this.autoCompleteSearchText = '';
		}
		this.internalSet = false;
	}

	_formatTitle() {
		this.controlLabel = this.label || (this.noLabel ? '' : this.defaultPickerLabel);
	}
}
